import React from "react";
import ImageSection from "../../components/common/ImageSection";
import {
  FaFacebookF,
  FaInstagram,
  FaLinkedinIn,
} from "react-icons/fa6";
import { NavLink } from "react-router-dom";

const Career = () => {
  return (
    <>
      <ImageSection name={"Careers"} />
      <section className="relative p-4 md:p-8 lg:p-0 lg:py-0 my-5 lg:my-10 xl:pb-0 overflow-hidden">
        <div className="lg:max-w-4xl xl:max-w-5xl 2xl:max-w-[1180px] 3xl:max-w-[1494px] mx-auto 4xl:max-w-[1520px] 4xl:mx-auto ">
          <div className="p-2 text-center">
            {/* <h3 className="mb-4 lg:mb-5 text-[#A5302E] sm:text-xl md:text-2xl lg:text-[28px] 3xl:text-4xl font-medium">
              OPEN POSITION
            </h3> */}
            <h2 className="mb-3 lg:mb-5 text-[#A5302E] text-xl sm:text-2xl md:text-4xl lg:text-5xl 3xl:text-6xl font-normal">
              Coming Soon
            </h2>
            <p className="mb-3 lg:mb-5 text-center text-[#555] lg:text-[#000000] text-xs sm:text-base md:text-sm lg:text-xl 3xl:text-2xl font-normal break-words">
              We're busy preparing our career opportunities.<br/> Stay tuned for
              exciting job openings.
            </p>

            <div className="flex justify-center items-center gap-5">
              <NavLink to={""} className="bg-[#080808] text-white hover:bg-transparent border border-[#080808] hover:text-[#080808] p-3 rounded-[50%]">
                <FaFacebookF />
              </NavLink>
              <NavLink to={""} className="bg-[#080808] text-white hover:bg-transparent border border-[#080808] hover:text-[#080808] p-3 rounded-[50%]">
                <FaLinkedinIn />
              </NavLink>
              <NavLink to={""} className="bg-[#080808] text-white hover:bg-transparent border border-[#080808] hover:text-[#080808] p-3 rounded-[50%]">
                <FaInstagram />
              </NavLink>
            </div>
            {/* <p className="text-center text-[#555] lg:text-[#000000] text-xs sm:text-base md:text-sm 3xl:text-xl font-normal break-words">
              Are you a passionate and skilled professional looking to make a
              significant impact? We are actively seeking{" "}
              <br className="hidden lg:block" /> talented individuals to join
              our dynamic team.
            </p> */}
          </div>
          {/* <div className="p-2 text-center">
            <h3 className="mb-4 lg:mb-5 text-[#A5302E] sm:text-xl md:text-2xl lg:text-[28px] 3xl:text-4xl font-medium">
              OPEN POSITION
            </h3>
            <h2 className="mb-3 lg:mb-5 text-[#222222] text-xl sm:text-2xl md:text-4xl lg:text-[42px] 3xl:text-[52px] font-normal">
              We’re looking for talented people
            </h2>
            <p className="text-center text-[#555] lg:text-[#000000] text-xs sm:text-base md:text-sm 3xl:text-xl font-normal break-words">
              Are you a passionate and skilled professional looking to make a
              significant impact? We are actively seeking{" "}
              <br className="hidden lg:block" /> talented individuals to join
              our dynamic team.
            </p>
          </div> */}
          {/* <div className="mt-5  lg:mt-14 3xl:mt-[91px] mb-5 lg:mb-8 p-2 sm:p-4 md:p-6 lg:p-4 2xl:p-5 3xl:p-8 border border-[#A5302E]">
            <div className=" flex justify-between items-center">
              <div className="flex flex-col gap-1 lg:gap-4">
                <h2 className="text-[#A5302E] text-xs xs:text-sm sm:text-base md:text-lg lg:text-[24px] 3xl:text-[28px] font-medium">
                  UX And UI Designer
                </h2>
                <div className="flex gap-1 lg:gap-12 2xl:gap-12 3xl:gap-16">
                  <span className="flex items-center gap-1 lg:gap-3">
                    <FaClock className="text-[#A5302E] text-xs xs:text-xs sm:text-base md:text-lg" />
                    <p className="text-[#222222] text-xs xs:text-xs sm:text-base md:text-lg lg:text-lg font-normal">
                      Full time
                    </p>
                  </span>
                  <span className="flex items-center gap-1 lg:gap-3">
                    <PiMapPinFill className="text-[#A5302E] text-xs xs:text-xs sm:text-base md:text-lg lg:text-xl" />
                    <p className="text-[#222222] text-xs xs:text-xs sm:text-base md:text-lg lg:text-lg font-normal">
                      On Site
                    </p>
                  </span>
                </div>
              </div>
              <div className="flex justify-between items-center gap-2 md:gap-4 lg:gap-8 2xl:gap-10 3xl:gap-20">
                <div className="lg:py-5 px-2 md:px-4 lg:pr-20 2xl:pr-44 3xl:pr-52 lg:pl-10 border-x border-x-[#929292] flex flex-col items-start">
                  <p className="text-[#222222] text-xs xs:text-xs sm:text-base md:text-lg lg:text-lg 2xl:text-base 3xl:text-lg  font-normal">
                    05 Dec, 2023
                  </p>
                  <p className="text-[#222222] text-xs xs:text-xs sm:text-base md:text-lg lg:text-lg 2xl:base 3xl:text-lg font-normal">
                    No of vacancies: <span className="text-[#A5302E]">2</span>
                  </p>
                </div>
                <div className="flex justify-center items-center lg:mr-5">
                  <button
                    className="py-1 px-4 sm:py-2 sm:px-6 md:py-2 md:px-8 lg:py-2 lg:px-14 hover:lg:py-2 hover:lg:px-14 bg-[#A5302E]
                   text-[#fff] border border-transparent hover:bg-transparent hover:border hover:border-[#A5302E] hover:text-[#A5302E]
                    text-[10px] xs:text-xs sm:text-base md:text-lg lg:text-lg 3xl:text-[22px] transition"
                  >
                    Apply
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className="mb-5 lg:mb-10 p-2 sm:p-4 md:p-6 lg:p-4 2xl:p-5 3xl:p-8 border border-[#A5302E]">
            <div className=" flex justify-between items-center">
              <div className="flex flex-col gap-1 lg:gap-4">
                <h2 className="text-[#A5302E] text-xs xs:text-sm sm:text-base md:text-lg lg:text-[24px] 3xl:text-[28px] font-medium">
                  Javascript Developer
                </h2>
                <div className="flex gap-1 lg:gap-12 2xl:gap-12 3xl:gap-16">
                  <span className="flex items-center gap-1 lg:gap-3">
                    <FaClock className="text-[#A5302E] text-xs xs:text-xs sm:text-base md:text-lg" />
                    <p className="text-[#222222] text-xs xs:text-xs sm:text-base md:text-lg lg:text-lg font-normal">
                      Full time
                    </p>
                  </span>
                  <span className="flex items-center gap-1 lg:gap-3">
                    <PiMapPinFill className="text-[#A5302E] text-xs xs:text-xs sm:text-base md:text-lg lg:text-xl" />
                    <p className="text-[#222222] text-xs xs:text-xs sm:text-base md:text-lg lg:text-lg font-normal">
                      On Site
                    </p>
                  </span>
                </div>
              </div>
              <div className="flex justify-between items-center gap-2 md:gap-4 lg:gap-8 2xl:gap-10 3xl:gap-20">
                <div className="lg:py-5 px-2 md:px-4 lg:pr-20 2xl:pr-44 3xl:pr-52 lg:pl-10 border-x border-x-[#929292] flex flex-col items-start">
                  <p className="text-[#222222] text-xs xs:text-xs sm:text-base md:text-lg lg:text-lg 2xl:text-base 3xl:text-lg  font-normal">
                    05 Dec, 2023
                  </p>
                  <p className="text-[#222222] text-xs xs:text-xs sm:text-base md:text-lg lg:text-lg 2xl:base 3xl:text-lg font-normal">
                    No of vacancies: <span className="text-[#A5302E]">2</span>
                  </p>
                </div>
                <div className="flex justify-center items-center lg:mr-5">
                  <button
                    className="py-1 px-4 sm:py-2 sm:px-6 md:py-2 md:px-8 lg:py-2 lg:px-14 hover:lg:py-2 hover:lg:px-14 bg-[#A5302E]
                   text-[#fff] border border-transparent hover:bg-transparent hover:border hover:border-[#A5302E] hover:text-[#A5302E]
                    text-[10px] xs:text-xs sm:text-base md:text-lg lg:text-lg 3xl:text-[22px] transition"
                  >
                    Apply
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className="mb-5 lg:mb-10 p-2 sm:p-4 md:p-6 lg:p-4 2xl:p-5 3xl:p-8 border border-[#A5302E]">
            <div className=" flex justify-between items-center">
              <div className="flex flex-col gap-1 lg:gap-4">
                <h2 className="text-[#A5302E] text-xs xs:text-sm sm:text-base md:text-lg lg:text-[24px] 3xl:text-[28px] font-medium">
                  Angular JS
                </h2>
                <div className="flex gap-1 lg:gap-12 2xl:gap-12 3xl:gap-16">
                  <span className="flex items-center gap-1 lg:gap-3">
                    <FaClock className="text-[#A5302E] text-xs xs:text-xs sm:text-base md:text-lg" />
                    <p className="text-[#222222] text-xs xs:text-xs sm:text-base md:text-lg lg:text-lg font-normal">
                      Full time
                    </p>
                  </span>
                  <span className="flex items-center gap-1 lg:gap-3">
                    <PiMapPinFill className="text-[#A5302E] text-xs xs:text-xs sm:text-base md:text-lg lg:text-xl" />
                    <p className="text-[#222222] text-xs xs:text-xs sm:text-base md:text-lg lg:text-lg font-normal">
                      On Site
                    </p>
                  </span>
                </div>
              </div>
              <div className="flex justify-between items-center gap-2 md:gap-4 lg:gap-8 2xl:gap-10 3xl:gap-20">
                <div className="lg:py-5 px-2 md:px-4 lg:pr-20 2xl:pr-44 3xl:pr-52 lg:pl-10 border-x border-x-[#929292] flex flex-col items-start">
                  <p className="text-[#222222] text-xs xs:text-xs sm:text-base md:text-lg lg:text-lg 2xl:text-base 3xl:text-lg  font-normal">
                    05 Dec, 2023
                  </p>
                  <p className="text-[#222222] text-xs xs:text-xs sm:text-base md:text-lg lg:text-lg 2xl:base 3xl:text-lg font-normal">
                    No of vacancies: <span className="text-[#A5302E]">2</span>
                  </p>
                </div>
                <div className="flex justify-center items-center lg:mr-5">
                  <button
                    className="py-1 px-4 sm:py-2 sm:px-6 md:py-2 md:px-8 lg:py-2 lg:px-14 hover:lg:py-2 hover:lg:px-14 bg-[#A5302E]
                   text-[#fff] border border-transparent hover:bg-transparent hover:border hover:border-[#A5302E] hover:text-[#A5302E]
                    text-[10px] xs:text-xs sm:text-base md:text-lg lg:text-lg 3xl:text-[22px] transition"
                  >
                    Apply
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className="mb-5 lg:mb-10 p-2 sm:p-4 md:p-6 lg:p-4 2xl:p-5 3xl:p-8 border border-[#A5302E]">
            <div className=" flex justify-between items-center">
              <div className="flex flex-col gap-1 lg:gap-4">
                <h2 className="text-[#A5302E] text-xs xs:text-sm sm:text-base md:text-lg lg:text-[24px] 3xl:text-[28px] font-medium">
                  Front end Developer
                </h2>
                <div className="flex gap-1 lg:gap-12 2xl:gap-12 3xl:gap-16">
                  <span className="flex items-center gap-1 lg:gap-3">
                    <FaClock className="text-[#A5302E] text-xs xs:text-xs sm:text-base md:text-lg" />
                    <p className="text-[#222222] text-xs xs:text-xs sm:text-base md:text-lg lg:text-lg font-normal">
                      Full time
                    </p>
                  </span>
                  <span className="flex items-center gap-1 lg:gap-3">
                    <PiMapPinFill className="text-[#A5302E] text-xs xs:text-xs sm:text-base md:text-lg lg:text-xl" />
                    <p className="text-[#222222] text-xs xs:text-xs sm:text-base md:text-lg lg:text-lg font-normal">
                      On Site
                    </p>
                  </span>
                </div>
              </div>
              <div className="flex justify-between items-center gap-2 md:gap-4 lg:gap-8 2xl:gap-10 3xl:gap-20">
                <div className="lg:py-5 px-2 md:px-4 lg:pr-20 2xl:pr-44 3xl:pr-52 lg:pl-10 border-x border-x-[#929292] flex flex-col items-start">
                  <p className="text-[#222222] text-xs xs:text-xs sm:text-base md:text-lg lg:text-lg 2xl:text-base 3xl:text-lg  font-normal">
                    05 Dec, 2023
                  </p>
                  <p className="text-[#222222] text-xs xs:text-xs sm:text-base md:text-lg lg:text-lg 2xl:base 3xl:text-lg font-normal">
                    No of vacancies: <span className="text-[#A5302E]">2</span>
                  </p>
                </div>
                <div className="flex justify-center items-center lg:mr-5">
                  <button
                    className="py-1 px-4 sm:py-2 sm:px-6 md:py-2 md:px-8 lg:py-2 lg:px-14 hover:lg:py-2 hover:lg:px-14 bg-[#A5302E]
                   text-[#fff] border border-transparent hover:bg-transparent hover:border hover:border-[#A5302E] hover:text-[#A5302E]
                    text-[10px] xs:text-xs sm:text-base md:text-lg lg:text-lg 3xl:text-[22px] transition"
                  >
                    Apply
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className="mb-5 lg:mb-10 p-2 sm:p-4 md:p-6 lg:p-4 2xl:p-5 3xl:p-8 border border-[#A5302E]">
            <div className=" flex justify-between items-center">
              <div className="flex flex-col gap-1 lg:gap-4">
                <h2 className="text-[#A5302E] text-xs xs:text-sm sm:text-base md:text-lg lg:text-[24px] 3xl:text-[28px] font-medium">
                  UX And UI Designer
                </h2>
                <div className="flex gap-1 lg:gap-12 2xl:gap-12 3xl:gap-16">
                  <span className="flex items-center gap-1 lg:gap-3">
                    <FaClock className="text-[#A5302E] text-xs xs:text-xs sm:text-base md:text-lg" />
                    <p className="text-[#222222] text-xs xs:text-xs sm:text-base md:text-lg lg:text-lg font-normal">
                      Full time
                    </p>
                  </span>
                  <span className="flex items-center gap-1 lg:gap-3">
                    <PiMapPinFill className="text-[#A5302E] text-xs xs:text-xs sm:text-base md:text-lg lg:text-xl" />
                    <p className="text-[#222222] text-xs xs:text-xs sm:text-base md:text-lg lg:text-lg font-normal">
                      On Site
                    </p>
                  </span>
                </div>
              </div>
              <div className="flex justify-between items-center gap-2 md:gap-4 lg:gap-8 2xl:gap-10 3xl:gap-20">
                <div className="lg:py-5 px-2 md:px-4 lg:pr-20 2xl:pr-44 3xl:pr-52 lg:pl-10 border-x border-x-[#929292] flex flex-col items-start">
                  <p className="text-[#222222] text-xs xs:text-xs sm:text-base md:text-lg lg:text-lg 2xl:text-base 3xl:text-lg  font-normal">
                    05 Dec, 2023
                  </p>
                  <p className="text-[#222222] text-xs xs:text-xs sm:text-base md:text-lg lg:text-lg 2xl:base 3xl:text-lg font-normal">
                    No of vacancies: <span className="text-[#A5302E]">2</span>
                  </p>
                </div>
                <div className="flex justify-center items-center lg:mr-5">
                  <button
                    className="py-1 px-4 sm:py-2 sm:px-6 md:py-2 md:px-8 lg:py-2 lg:px-14 hover:lg:py-2 hover:lg:px-14 bg-[#A5302E]
                   text-[#fff] border border-transparent hover:bg-transparent hover:border hover:border-[#A5302E] hover:text-[#A5302E]
                    text-[10px] xs:text-xs sm:text-base md:text-lg lg:text-lg 3xl:text-[22px] transition"
                  >
                    Apply
                  </button>
                </div>
              </div>
            </div>
          </div> */}
        </div>
      </section>
    </>
  );
};

export default Career;
